'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useProps } from '@s7/styles';
import { IDENT, defaultProps } from './UnstyledButton.contract.js';
import useStyles from './UnstyledButton.styles.js';
import { optionallyWrapped } from '../utils/optionallyWrapped.js';
import { createPolymorphicComponent } from '../utils/PolymorphicComponent/PolymorphicComponent.js';
import { Box } from '../Box/Box.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _UnstyledButton = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _useProps = useProps(IDENT, defaultProps, props), _useProps_ = _useProps[0], className = _useProps_.className, _useProps__as = _useProps_.as, as = _useProps__as === void 0 ? "button" : _useProps__as, notAllowed = _useProps_.notAllowed, __wrapperAttributes = _useProps_.__wrapperAttributes, sxs = _useProps[1], others = _object_without_properties_loose(_useProps[0], [
        "className",
        "as",
        "notAllowed",
        "__wrapperAttributes"
    ]);
    var _useStyles = useStyles(null, sxs, IDENT), classes = _useStyles[0], cx = _useStyles[1];
    /* ??? */ return optionallyWrapped(/*#__PURE__*/ jsx(Box, _extends({
        ref: ref,
        as: as,
        className: cx(classes.root, className),
        type: as === "button" ? "button" : undefined
    }, others)), notAllowed, _extends({
        className: classes.wrapper
    }, __wrapperAttributes));
});
var UnstyledButton = createPolymorphicComponent(_UnstyledButton);
UnstyledButton.displayName = IDENT;
var UnstyledButton$1 = UnstyledButton;

export { UnstyledButton, _UnstyledButton, UnstyledButton$1 as default };
